import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import "./Links.css";
import { LanguageContext } from "../../context/LanguageContext";
import { Link } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const Links = () => {
  const { currentLang } = useContext(LanguageContext);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const resolveUrl = (url) => {
    if (!url) return "";
    return url.startsWith("http") ? url : `${API_BASE}${url}`;
  };

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/LinksSection?lang=${currentLang}`
        );
        setData(res.data);
      } catch (err) {
        console.error("Failed to fetch Links section:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, [currentLang]);

  if (loading || !data) return null;

  return (
    <div className="links-section">
      <div className="links-grid">
        {/* Left column */}
        <div className="links-column">

  

          {/* EREV */}
          <div className="link-card">
            <div className="image-wrapper">
              <img
                src={resolveUrl(data.specificationErevImageUrl)}
                alt="Specification EREV"
                loading="lazy"
              />
            </div>
            <Link to="/specifications2" className="link-text">
              {data.specificationErevText}
            </Link>
          </div>
        </div>

        {/* Right column */}
        <div className="links-column">
          <div className="link-card">
            <div className="image-wrapper">
              <img
                src={resolveUrl(data.specificationBevImageUrl)}
                alt="Specifications BEV"
                loading="lazy"
              />
            </div>
            <Link to="/specifications1" className="link-text">
              {data.specificationBevText}
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Links;
